import {Apollo} from 'apollo-angular';
import {NetworkOperationResult} from '../../types';
import {Observable, Subject, Subscription} from 'rxjs';
import {Injectable} from '@angular/core';
import {MDBModalService} from 'ng-uikit-pro-standard';
import {HttpClient} from '@angular/common/http';
import {
  ReservationReviewDetailsQueryResult, S3_file_deleteResult, S3_file_download_generate_presigned_URLResult,
  S3_file_toggle_acceptance_flagResult,
  S3_file_upload_client_confirm_upload_completeResult,
  S3_file_upload_create_presigned_post_attributesResult,
} from '../results';
import {
  S3_file_upload_create_presigned_post_attributes,
  refreshReservationsAttachmentsQuery, S3_file_download_generate_presigned_URL
} from '../queries';
import {S3_FileContext_Type, S3_FileExistsErrorHandling_Type} from '../../_models/S3/S3';
import {
  S3_file_deleteMutation,
  S3_file_toggle_acceptance_flag,
  S3_file_upload_client_confirm_upload_completeMutation,
} from "../mutationDefinitions/S3_definitions";

@Injectable({providedIn: 'root'})
export class S3FileManipulations {
  constructor(
    private apollo: Apollo,
    private http: HttpClient,
    private modalService: MDBModalService) {
  }

  genericFilePOSTUploader(file: File, formAttributes: any, formInputs: any) : Observable<NetworkOperationResult> {
    let retVal = new Subject<NetworkOperationResult>();

    let formData = new FormData();
    for (let key in formInputs){
      formData.append(key, formInputs[key]);
    }
    formData.append("file", file);


    this.http.post(formAttributes.action, formData)
      .subscribe(
        (data) => {
          retVal.next({status: "OK", message: "Plik został przesłany na serwer."});
          retVal.complete();
        },
        (error) => {
          console.log("error: ", error);
          retVal.next({status: "ERROR", message: "Podczas próby wysyłania pliku na serwer wystąpił błąd. Spróbuj ponownie."});
          retVal.complete();
        },
        () => {

        });

    return retVal.asObservable();
  }

  S3UploadFile(
              context: S3_FileContext_Type,
              parent_object_id: number,
              file_already_exists_handling: S3_FileExistsErrorHandling_Type,
              remoteName: string, attachmentFile: File): Observable<NetworkOperationResult> {

    const retVal = new Subject<NetworkOperationResult>();

    console.log(attachmentFile);

    let presignedPOSTSubscription: Subscription = this.apollo.watchQuery<S3_file_upload_create_presigned_post_attributesResult>({
      query: S3_file_upload_create_presigned_post_attributes,
      fetchPolicy: 'network-only',
      variables: {
        context,
        parent_object_id,
        file_already_exists_handling,
        file_name: remoteName
      }
    })
      .valueChanges
      .subscribe(
        ({data, loading}) => {
          if (loading) {
            return;
          }

          presignedPOSTSubscription.unsubscribe();

          if (data.S3_file_upload_create_presigned_post_attributes.status == "OK"){
            let formAttributes = JSON.parse(data.S3_file_upload_create_presigned_post_attributes.formAttributes);
            let formInputs = JSON.parse(data.S3_file_upload_create_presigned_post_attributes.formInputs);

            let full_file_key = data.S3_file_upload_create_presigned_post_attributes.full_file_key;
            let file_hash = data.S3_file_upload_create_presigned_post_attributes.file_hash;

            // now upload the file with given credentials
            let uploadSubscription = this.genericFilePOSTUploader(attachmentFile, formAttributes, formInputs).subscribe(
              (data) => {
                if (data.status === 'OK'){

                  // to update UI faster - without waiting for confirmation from S3 server, we now confirm the upload on our own
                  let confirmUploadSubscription: Subscription = this.apollo.mutate<S3_file_upload_client_confirm_upload_completeResult>({
                    mutation: S3_file_upload_client_confirm_upload_completeMutation,
                    variables: {
                      full_file_key: full_file_key,
                      file_size: attachmentFile.size,
                      file_hash: file_hash
                    }
                  }).subscribe(({ data }) => {
                    if (data.S3_file_upload_client_confirm_upload_complete.status == "OK"){
                      retVal.next({status: 'OK', message: 'Plik został przesłany na serwer.'});
                      retVal.complete();
                    }
                    else if (data.S3_file_upload_client_confirm_upload_complete.status.startsWith('Error: ')){
                      //log error message
                      console.error(data.S3_file_upload_client_confirm_upload_complete.status);

                      retVal.next({status: 'ERROR', message: 'Podczas przesyłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
                      retVal.complete();
                    }
                  },
            (error) => {
                      retVal.next({status: 'ERROR', message: 'Podczas przesyłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
                      retVal.complete();
                    },
                    () => {
                      confirmUploadSubscription.unsubscribe();
                      confirmUploadSubscription = null;
                    }
                  )
                }
                else {
                  retVal.next({status: 'ERROR', message: 'Podczas przesyłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
                  retVal.complete();
                }

              },
              (error) => {
                retVal.next({status: 'ERROR', message: 'Podczas przesyłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
                retVal.complete();
              },
              () => {
                uploadSubscription.unsubscribe();
                uploadSubscription = null;
              }
            );
          }
          else {
            retVal.next({status: 'ERROR', message: 'Podczas próby uzyskania danych do przesłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
            retVal.complete();
            return;
          }
        },
        (error) => {
          retVal.next({status: 'ERROR', message: 'Podczas próby wysyłania pliku na serwer wystąpił błąd. Spróbuj ponownie.'});
          retVal.complete();
        },
        () => {
          presignedPOSTSubscription.unsubscribe();
          presignedPOSTSubscription = null;
        });

    return retVal.asObservable();
  }

  // This method is used to toggle 'accepted' flag of a file with a geven key
  public S3ToggleFileAcceptanceFlag(file_key: string) : Observable<NetworkOperationResult>{
    let retVal = new Subject<NetworkOperationResult>();

    let localSub = this.apollo.mutate<S3_file_toggle_acceptance_flagResult>({
      mutation: S3_file_toggle_acceptance_flag,
      variables: {
        full_file_key: file_key
      }
    }).subscribe(({data}) => {
        if (data.S3_file_toggle_acceptance_flag.status.startsWith('Error')){
          retVal.next({
            status: "ERROR",
            message: "Coś poszło nie tak podczas zmiany statusu załącznika!",
          });
          retVal.complete();
        }
        else {
          retVal.next({
            status: "OK",
            message: "Pomyślnie zmieniono status załącznika!"
          });
          retVal.complete();
        }

        // don't forget to unsubscribe
        localSub.unsubscribe();
      },
      error => {
        retVal.next({
          status: "ERROR",
          message: "Coś poszło nie tak podczas zmiany statusu załącznika! Spróbuj ponownie lub skontaktuj się z nami."
        });
        retVal.complete();
        localSub.unsubscribe();
      },
      () => {
        localSub.unsubscribe();
        localSub = null;
      }
    );

    return retVal.asObservable();
  }

  // method to delete attachment with given key from reservation
  public S3DeleteFile(file_key: string, comment?: string) : Observable<NetworkOperationResult>{
    let retVal = new Subject<NetworkOperationResult>();

    let localSub = this.apollo.mutate<S3_file_deleteResult>({
      mutation: S3_file_deleteMutation,
      variables: {
        full_file_key: file_key,
        comment
      }
    }).subscribe(({data}) => {
        if (data.S3_file_delete.status.startsWith('Error')){
          retVal.next({
            status: "ERROR",
            message: "Coś poszło nie tak podczas usuwania pliku!",
          });
          retVal.complete();
        }
        else {
          retVal.next({
            status: "OK",
            message: "Pomyślnie usunięto załącznik!"
          });
          retVal.complete();
        }

        // don't forget to unsubscribe
        localSub.unsubscribe();
      },
      error => {
        retVal.next({
          status: "ERROR",
          message: "Coś poszło nie tak podczas usuwania pliku! Spróbuj ponownie lub skontaktuj się z nami."
        });
        retVal.complete();
        localSub.unsubscribe();
      },
      () => {
        localSub.unsubscribe();
        localSub = null;
      }
    );

    return retVal.asObservable();
  }



  public refreshReservationsAttachments(reservationID: number) : Observable<NetworkOperationResult> {
    let retVal = new Subject<NetworkOperationResult>();

    let reservationSubscription : Subscription = this.apollo.watchQuery<ReservationReviewDetailsQueryResult>({
      query: refreshReservationsAttachmentsQuery,
      fetchPolicy: "network-only",
      variables: {
        camp_participant_id: reservationID,
      }
    })
      .valueChanges
      .subscribe(
        ({data, loading}) => {
          if (loading) {
            return;
          }

          reservationSubscription.unsubscribe();
          let reservationData = data.reservation_review_details.camp_participant;
          retVal.next({status: "OK", message: "Załączniki zostały odświeżone."});
        },
        (error) => {
          retVal.next({status: "ERROR", message: "Podczas próby odświeżenia załączników wystąpił błąd. Spróbuj ponownie."});
          retVal.complete();
        },
        () => {
          reservationSubscription.unsubscribe();
          reservationSubscription = null;
        });

    return retVal.asObservable();
  }

  public S3FileDownloadGeneratePresignedURL(full_file_key: string, file_name: string) : Observable<NetworkOperationResult> {
    let retVal = new Subject<NetworkOperationResult>();

    let presignedURLSubscription : Subscription = this.apollo.watchQuery<S3_file_download_generate_presigned_URLResult>({
      query: S3_file_download_generate_presigned_URL,
      fetchPolicy: "network-only",
      variables: {
        full_file_key
      }
    })
      .valueChanges
      .subscribe(
        ({data, loading}) => {
          if (loading) {
            return;
          }

          presignedURLSubscription.unsubscribe();

          if (data.S3_file_download_generate_presigned_URL.status == "OK"){
            let presignedURL = data.S3_file_download_generate_presigned_URL.url;

            // use HTML5 feature of a href download
            var link = document.createElement('a');
            link.download = file_name;
            link.href = presignedURL;
            link.setAttribute('target', '_blank');
            link.click();
            link.remove();


            retVal.next({status: "OK", message: "Pomyślnie uzyskano adres URL.", data: presignedURL});
            retVal.complete();
          }
          else {
            retVal.next({status: "ERROR", message: "Podczas próby uzyskania adresu URL wystąpił błąd. Spróbuj ponownie."});
            retVal.complete();
            return;
          }
        },
        (error) => {
          retVal.next({status: "ERROR", message: "Podczas próby uzyskania adresu URL wystąpił błąd. Spróbuj ponownie."});
          retVal.complete();
        },
        () => {
          presignedURLSubscription.unsubscribe();
          presignedURLSubscription = null;
        });

    return retVal.asObservable();
  }
}
